const alertsStyle = Object.freeze({
  inputVariant: 'neutral',
});

export default alertsStyle;
